import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import React, { useEffect, useState } from 'react';
import { editQuestionnaire } from 'Consts/Questionnaire';
import relationships from 'Consts/Relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useModalClosedEffect from 'Hooks/useModalClosedEffect';
import modalConsts from 'Consts/ModalNames';
import { REAL_ASSET_QUERY_VALUE_ID, REAL_ASSET_QUERY_VALUE_TYPE, REAL_ASSET_TYPE_BUSINESS } from 'Consts/RealAssets';
import { openModal } from 'Helpers/ModalHelper';
import { buildModalQuery } from 'Consts/ModalQueries';
import PropTypes from 'prop-types';
import View from './View';

const Controller = ({ isAgent }) => {
  const { householdResource } = useSimpleHousehold();
  const [realAssetsCollection, setRealAssetsCollection] = useState();

  function getEditLink(page, section) {
    return editQuestionnaire(page, {
      isAgent,
      section,
      householdId: householdResource.id(),
    });
  }

  const refreshRealAssets = async () => {
    return householdResource.relationship(relationships.realAssets).link('related').get()
      .then(newRealAssetsCollection => setRealAssetsCollection(newRealAssetsCollection));
  };

  const getRealAssetsOfType = (realAssetType) => {
    if (!realAssetsCollection) {
      return [];
    }
    const result = realAssetsCollection.resources().list().filter(realAsset => realAsset.attr('type') === realAssetType);
    return result !== undefined ? result : [];
  };

  useEffect(() => {
    if (householdResource !== undefined) {
      refreshRealAssets()
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  useModalClosedEffect(modalConsts.realAssetModal, () => {
    refreshRealAssets()
      .catch(err => displayErrorMessage(err, err.errors));
  });

  return (
    <View
      businessAssets={getRealAssetsOfType(REAL_ASSET_TYPE_BUSINESS)}
      getEditLink={householdResource ? getEditLink : null}
      onClickEdit={(realAsset) => {
        const realAssetQuery = {};
        realAssetQuery[REAL_ASSET_QUERY_VALUE_ID] = realAsset.id();
        realAssetQuery[REAL_ASSET_QUERY_VALUE_TYPE] = realAsset.attr('type');
        openModal(buildModalQuery(modalConsts.realAssetModal, realAssetQuery));
      }}
    />
  );
};
Controller.propTypes = {
  isAgent: PropTypes.bool.isRequired,
};

export default Controller;
